import { v4 } from 'uuid';

/**
 * Generates an RFC 9562 version 4 UUID.
 *
 * `uuid.v4()` uses `crypto.randomUUID` when available and falls back to
 * `crypto.getRandomValues` below Chrome 92.
 *
 * The runtime fallback supports the Chrome 80 fleet floor. Consuming apps
 * must bundle dependencies with syntax lowering targeting Chrome 80.
 *
 * @example
 * const ackId = randomUuid();
 */
export function randomUuid(): string {
  return v4();
}
